import css from 'styled-jsx/css';
import { common } from '../../theme/theme';

const style = css`
  .confirm-block-modal {
    width: 400px;
    padding: 16px;
    max-height: 565px;
    overflow: auto;
  }
  .label {
    font-size: 14px;
    margin-bottom: 6px;
  }
  .confirm-block-modal-inputs {
    width: 100%;
    padding-bottom: 16px;
  }
  .confirm-block-wrapper,
  .reason-selector-wrapper {
    margin-bottom: 8px;
  }
  .confirm-block-modal :global(.submit-button-confirm-block) {
    width: 100%;
    font-size: 16px;
    margin: 8px 0;
    border-radius: 8px;
    display: flex;
    justify-content: center;
    color: #ed4e4d;
    background: #ffffff;
    border: 2px solid #ed4e4d;
  }
  .confirm-block-modal :global(.submit-button-confirm-block:hover) {
    width: 100%;
    font-size: 16px;
    margin: 8px 0;
    border-radius: 8px;
    display: flex;
    justify-content: center;
    color: #ffffff;
    background: #ed4e4d;
    border: 2px solid #ed4e4d;
  }
  .confirm-block-modal :global(.cancel-button) {
    ${common.button}
    ${common.cancelButton}
  }
  .confirm-block-modal :global(.cancel-button:hover) {
    ${common.button}
    ${common.cancelButton}
  }
`;

export default style;
